/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { SearchProductVariant } from './search-product-variant';

/**
 * 
 * @export
 * @interface SearchProductEntity
 */
export interface SearchProductEntity {
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SearchProductEntity
     */
    'title': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchProductEntity
     */
    'embedding': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SearchProductEntity
     */
    'article': string;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'minPrice': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'maxPrice': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'brandId': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'categoryId': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'level1CategoryId': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'level2CategoryId': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'fitId': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'sellDate': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchProductEntity
     */
    'seasons': Array<SearchProductEntitySeasonsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchProductEntity
     */
    'colors': Array<string>;
    /**
     * 
     * @type {Array<SearchProductVariant>}
     * @memberof SearchProductEntity
     */
    'variants': Array<SearchProductVariant>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchProductEntity
     */
    'isStock': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchProductEntity
     */
    'isTrend': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchProductEntity
     */
    'isPopular': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchProductEntity
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchProductEntity
     */
    'logo': string;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'likes': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'orders': number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductEntity
     */
    'seriesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchProductEntity
     */
    'updatedAt'?: string;
}

export const SearchProductEntitySeasonsEnum = {
    Winter: 'WINTER',
    Spring: 'SPRING',
    Summer: 'SUMMER',
    Autumn: 'AUTUMN'
} as const;

export type SearchProductEntitySeasonsEnum = typeof SearchProductEntitySeasonsEnum[keyof typeof SearchProductEntitySeasonsEnum];


